import type { CustomApi } from '.';

export const getIsUrlValidForErrorModal = (url: string) => {
  return !url?.includes('medication_guide');
};

export const BffErrorMessages = {
  authenticationCredentialsWereNotProvided: 'Authentication credentials were not provided.',
};

export const WebErrorMessages = {
  oopsSomethingWentWrong: 'Oops, something went wrong!',
  pleaseRefreshThePage: 'Please refresh the page.',
  expiredSession: 'Your session has expired, please sign in.',
};

export const getCustomApiFlavorText = (customApi: CustomApi): string => {
  if (!customApi) return '';
  if (customApi?.flavorText === BffErrorMessages.authenticationCredentialsWereNotProvided) {
    return WebErrorMessages.expiredSession;
  } else {
    return WebErrorMessages.pleaseRefreshThePage;
  }
};
